import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { FinanceProvider } from "./contexts/FinanceContext";
import { DashboardProvider } from "./contexts/DashboardContext";
import { RemindersProvider } from "./contexts/RemindersContext";
import { GoalsProvider } from "./contexts/GoalsContext";
import { WorkHoursProvider } from "./contexts/WorkHoursContext";
import "./i18n";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <FinanceProvider>
          <DashboardProvider>
            <RemindersProvider>
              <GoalsProvider>
                <WorkHoursProvider>
                  <I18nextProvider i18n={i18n}>
                    <App />
                  </I18nextProvider>
                </WorkHoursProvider>
              </GoalsProvider>
            </RemindersProvider>
          </DashboardProvider>
        </FinanceProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);
